<script setup>
import { Icon } from '@iconify/vue';

const props = defineProps({
    tabs: {
        type: Array,
        default: () => []
    },
    modelValue: {
        type: [Number, String],
        default: null
    },
    wrapOnMobile: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['update:modelValue', 'change']);

const selectTab = (tab) => {
    emit('update:modelValue', tab.id);
    emit('change', tab);
};
</script>

<template>
    <div class="w-full xl:mt-auto border-b border-gray-200">
        <div class="w-full block">
            <div class="flex-1 min-w-0 flex items-end">
                <div v-if="tabs && tabs.length > 0" class="xl:pl-4 flex relative bottom-0 overflow-x-auto overflow-y-hidden w-full custom-scrollbar pb-1 gap-1 md:gap-3 xl:pb-0 xl:pt-1 z-50 -mb-[1px]" :class="wrapOnMobile ? 'flex-wrap' : 'flex-nowrap xl:flex-wrap'">
                    <template v-for="tab in tabs" :key="tab.id">
                        <button v-if="tab.show !== false" @click="selectTab(tab)" class="relative text-xs xl:text-sm font-bold transition-colors flex items-center justify-center shrink-0 px-3 py-1.5 rounded-lg xl:px-6 xl:py-2.5 xl:rounded-none xl:rounded-t-lg border" :class="[
                            modelValue === tab.id
                                ? 'bg-white text-slate-800 shadow-sm xl:shadow-none border-gray-200 xl:border-b-transparent xl:z-10'
                                : 'bg-slate-50 text-slate-600 hover:bg-slate-100 border xl:border-b-gray-200 xl:z-0'
                        ]">
                            <span class="flex items-center gap-2">
                                <Icon v-if="tab.icon" :icon="tab.icon" class="w-4 h-4" :class="{'hidden xl:block': !tab.showIconOnMobile}" />
                                {{ tab.label }}
                            </span>

                            <!-- Línea roja para el tab activo (solo visible en desktop xl+) -->
                            <div v-if="modelValue === tab.id" class="hidden xl:block absolute -bottom-[1px] left-4 right-4 h-[2px] bg-rose-600"></div>
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
